/**
 * @generated SignedSource<<4c1edfd8b8752562fdf929d31e6bb0a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "updatePassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePasswordFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "13114a70efec28be90ffbdfd60540252",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordFormMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePasswordFormMutation(\n  $input: UpdatePasswordInput!\n) {\n  updatePassword(input: $input)\n}\n"
  }
};
})();

node.hash = "eb7ab01aabe3fb869e046b091af5184b";

module.exports = node;
